const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de recepciones',
  PAGE_DESCRIPTION:
    'Desde aquí puedes visualizar y almacenar las recepciones que tienes pendientes y/o activas. Tambien tienes la opción de crear nuevas recepciones.'
};

export default HELPER_TEXTS;
